<template>
  <div class="bg-white p-5">
    <c_cell title="导入方式">
      <template #title>
        <el-tooltip
          effect="dark"
          content="若导入表格中的人员信息在系统人员库中存在，则根据当前选择的导入方式进行数据处理；其中《非覆盖导入》表示本次导入以表格数据为准，且不操作人员库。《覆盖导入》表示存在的人员信息由系统通过手机号码在人员库中比对获取并作为本次导入的最终数据。"
        >
          <div class="flex items-center">
            导入方式
            <el-icon class="cursor-pointer">
              <QuestionFilled />
            </el-icon>
          </div>
        </el-tooltip>
      </template>
      <el-radio-group v-model="state.is_import_cover" class="ml-3">
        <el-radio :value="0">非覆盖导入</el-radio>
        <el-radio :value="1">覆盖导入</el-radio>
      </el-radio-group>
    </c_cell>
    <div class="bg-gray-100 rounded p-2.5 mt-2">
      <div class="text-xs text-gray-400">
        下载导入模板，根据模板提示完善内容
      </div>
      <el-button
        icon="download"
        size="small"
        class="mt-1"
        plain
        @click="onDownLoad()"
        >下载模板</el-button
      >
    </div>
    <div class="bg-gray-100 rounded p-2.5 mt-3">
      <div class="text-xs text-gray-400">上传完善好的表格文件</div>
      <div
        class="bg-white py-10 flex flex-col items-center justify-center mt-2"
      >
        <el-image
          :src="require('@/assets/images/excel.png')"
          class="w-20 h-20"
        />
        <el-upload
          :show-file-list="false"
          :auto-upload="false"
          multiple
          :on-change="onChangeFile"
        >
          <el-button
            dashed
            plan
            icon="plus"
            style="
              border-color: var(--el-color-primary);
              color: var(--el-color-primary);
            "
            class="!text-xs hover:!text-green-600 hover:!border-green-600 mt-4"
            >上传文件
          </el-button>
        </el-upload>
        <text class="text-xs text-gray-400 mt-4">
          支持xls、xlsx文件，大小不超过300MB
        </text>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import {
  meeting_attendee_download,
  meeting_attendee_import,
} from "@/http/meeting";

export default {
  props: {
    meeting_id: Number,
  },
  setup(props, { emit }) {
    const state = reactive({
      is_import_cover: 0,
    });
    onMounted(() => {});

    const onDownLoad = () => {
      meeting_attendee_download()
        .then((res) => {
          if (res.status == 200) {
            let fileName = decodeURI(
              res.headers["content-disposition"].split("=")[1],
            );

            //通过后台返回 的word文件流设置文件名并下载
            var blob = new Blob([res.data], {
              type: res.data.type,
            });
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
          }
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    let handleFile = false;
    const onChangeFile = (file) => {
      if (!handleFile) {
        handleFile = true;
        ElMessageBox.confirm(
          `您确定<strong style='color:var(--el-color-warning)'>导入</strong><strong style='color:var(--el-color-primary)'>人员</strong>吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
            type: "warning",
            cancelButtonClass: "is-plain",
          },
        )
          .then(() => {
            const formData = new FormData();
            formData.append("meeting_id", props.meeting_id);
            if (state.is_import_cover)
              formData.append("is_import_cover", state.is_import_cover);
            formData.append("file", file.raw);

            meeting_attendee_import(formData)
              .then((res) => {
                handleFile = false;
                ElMessageBox.alert(res.data.data?.msg, "导入结果", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    emit("close", true);
                  },
                });
              })
              .catch(() => {
                handleFile = false;
              });
          })
          .catch(() => {
            handleFile = false;
          });
      }
    };

    return { state, onDownLoad, onChangeFile };
  },
};
</script>
<style scoped></style>
